// src/constants/apiConfig.js

const currentOrigin = typeof window === "undefined" ? "" : window.location.origin;

export const ApiConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || "https://e-prajogo.web.id/api",
  baseImageUrl:
    process.env.REACT_APP_API_IMAGE_URL !== undefined
      ? process.env.REACT_APP_API_IMAGE_URL
      : currentOrigin || "https://e-prajogo.web.id",
};
